<script>
import LinkSelector from '../Shared/LinkSelector.vue';

/**
 * The SeasonSelector component.
 */
export default {
  extends: LinkSelector
};
</script>
